import ContentCarouselCard from './ContentCarouselCard';

export default ContentCarouselCard;
